import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const ReloadIcon = ({ color }) => (
  <SvgIcon>
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.7046 5.83802C14.5394 5.574 14.1868 5.51307 13.9409 5.69589L12.2296 6.97976C12.0153 7.14095 11.9556 7.4376 12.0916 7.66882C12.5257 8.40784 12.7461 9.19885 12.7461 10.0202C12.7461 12.6374 10.6171 14.8359 8 14.8359C5.38286 14.8359 3.25391 12.6374 3.25391 10.0202C3.25391 7.58128 5.1027 5.56665 7.47266 5.30351V6.85618C7.47266 7.29331 7.9742 7.5367 8.31619 7.27795L12.5349 4.11389C12.8164 3.90334 12.816 3.48058 12.5349 3.27035L8.31619 0.106288C7.97296 -0.153622 7.47266 0.0923308 7.47266 0.528057V2.1276C3.35586 2.40002 0.0898438 5.83598 0.0898438 10.0202C0.0898438 14.3822 3.63809 18 8 18C12.3619 18 15.9102 14.3822 15.9102 10.0202C15.9102 8.54431 15.493 7.09823 14.7046 5.83802Z" fill={color} />
    </svg>
  </SvgIcon>
);

ReloadIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default ReloadIcon;
